import request from '@/utils/http';
/**
 * 函数节流
 * @param fn
 * @param interval
 * @returns {Function}
 * @constructor
 */
export const Throttle = (fn, t) => {
    let last;
    let timer;
    const interval = t || 500;
    return function () {
        const args = arguments;
        const now = +new Date();
        if (last && now - last < interval) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                last = now;
                fn.apply(this, args);
            }, interval);
        } else {
            last = now;
            fn.apply(this, args);
        }
    };
};

// 标识查询
export const getIdentifyingList = (params) => {
    return request({
        url: '/api-sn/identitys',
        method: 'post',
        data: params
    });
};
// 模板查询
export const getTemplate = (params) => {
    return request({
        url: '/api-sn/product/productTemplates/searchPage',
        method: 'post',
        data: params
    }).then(res => res);
};

// 标识状态停用启用
export const changeState = (params) => {
    return request({
        url: '/api-sn/identity/update',
        method: 'post',
        data: params
    });
};

// 标识详情
export const getList = (params) => {
    return request({
        url: `/api-sn/identity/${params[0]}/${params[1]}/${params[2]}`,
        method: 'get'
    });
};

// 获取图片密钥
export const getImgKey = (params) => {
    return request({
        url: '/api-sn/config/ossConfig/search',
        method: 'post',
        data: params
    });
};
